<template>
  <div class="container">
    <div class="row dado__head">
      <div class="col-12 col-lg-3">
        <div class="title">Monitors</div>
      </div>
      <div class="col-12 col-lg-9">
        <div class="row dado__separately">
          <div class="col-12 col-md-3">
            <label class="dado__label">Country</label>
            <vue-select v-model="filters.country" :options="getCountriesNames" label="name" @change="onFilter"></vue-select>
          </div>
          <div class="col-12 col-md-3">
            <label class="dado__label">Status</label>
            <vue-select v-model="filters.status" :options="statusesOptions" @change="onFilter"></vue-select>
          </div>
          <div class="col-12 col-md-3">
            <label class="dado__label">Search</label>
            <div class="search">
              <input type="text" v-model="filters.name" placeholder="Type here..." class="search__field"/>
              <span class="form__del" :class="{'d-block': filters.name.length}" @click="onClearName"></span>
              <button type="submit" class="search__btn" @click="onFilter"></button>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div @click="onShowCreateModal()" class="btn__add">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 14V1M14 7.5H1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Add Monitor
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <v-sidebar/>
      <div class="col-12 col-lg-10">
        <div class="monitors">
          <div class="dado__higher" :class="{active: selectedUsers.length}">
            <div class="dado__pick select">
              <label class="checkbox">
                <input type="checkbox" @change="onSelectAll($event)" :checked="selectedUsers.length"/><span class="checkbox__part"> </span>
              </label><span class='dado__result'>{{ selectedUsers.length }}</span> Select all
            </div>
            <div class="dado__pick cursor-pointer delete" @click="onMassDelete">
              <svg class='dado__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.1447 3.10532C17.0745 3.03517 16.9846 2.99991 16.8753 2.99991H13.2541L12.4338 1.04299C12.3166 0.753857 12.1056 0.507743 11.8011 0.304605C11.4963 0.101508 11.1875 0 10.8751 0H7.12503C6.81262 0 6.50395 0.101508 6.19927 0.304605C5.89454 0.507743 5.6836 0.753816 5.56637 1.04299L4.74606 2.99991H1.12496C1.01549 2.99991 0.92576 3.03517 0.855407 3.10532C0.785259 3.17563 0.75 3.26552 0.75 3.37487V4.12495C0.75 4.2343 0.785095 4.32419 0.855407 4.39438C0.92576 4.46465 1.01565 4.49978 1.12496 4.49978H2.24987V15.6562C2.24987 16.3048 2.43347 16.8574 2.80063 17.3144C3.16787 17.7716 3.60929 18 4.12495 18H13.8752C14.391 18 14.8323 17.7637 15.1995 17.2912C15.5667 16.8183 15.7502 16.2579 15.7502 15.6095V4.49978H16.8753C16.9846 4.49978 17.0745 4.46465 17.1447 4.39438C17.2148 4.32423 17.2502 4.2343 17.2502 4.12495V3.37487C17.2502 3.26552 17.2148 3.17563 17.1447 3.10532ZM6.94931 1.62864C7.00394 1.55836 7.07039 1.51527 7.14851 1.49975H10.8634C10.9415 1.51539 11.008 1.55845 11.0626 1.62864L11.6253 2.99975H6.37507L6.94931 1.62864ZM14.2503 15.6095C14.2503 15.7814 14.223 15.9396 14.1682 16.0841C14.1135 16.2285 14.0567 16.334 13.9983 16.4004C13.9395 16.467 13.8988 16.5 13.8752 16.5H4.12499C4.10155 16.5 4.06075 16.467 4.00202 16.4004C3.94336 16.334 3.88668 16.2285 3.83196 16.0841C3.77733 15.9396 3.74999 15.7812 3.74999 15.6095V4.49978H14.2503V15.6095H14.2503Z"
                      fill="white"/>
                <path d="M5.62496 14.2501H6.37491C6.48438 14.2501 6.57432 14.215 6.64446 14.1447C6.71461 14.0742 6.74987 13.9846 6.74987 13.8751V7.12483C6.74987 7.01553 6.71461 6.92564 6.64446 6.85528C6.57411 6.78514 6.48443 6.75 6.37491 6.75H5.62496C5.51549 6.75 5.42572 6.78509 5.35541 6.85528C5.28518 6.92564 5.25 7.01553 5.25 7.12483V13.8751C5.25 13.9846 5.28505 14.0743 5.35541 14.1447C5.42572 14.215 5.51549 14.2501 5.62496 14.2501Z"
                      fill="white"/>
                <path d="M8.62496 14.2501H9.37492C9.48435 14.2501 9.57424 14.215 9.64435 14.1447C9.71486 14.0742 9.74979 13.9846 9.74979 13.8751V7.12483C9.74979 7.01553 9.71482 6.92564 9.64435 6.85528C9.57424 6.78514 9.48435 6.75 9.37492 6.75H8.62496C8.51561 6.75 8.42572 6.78509 8.35541 6.85528C8.28505 6.92564 8.25 7.01553 8.25 7.12483V13.8751C8.25 13.9846 8.28505 14.0743 8.35541 14.1447C8.42568 14.215 8.51561 14.2501 8.62496 14.2501Z"
                      fill="white"/>
                <path d="M11.625 14.2501H12.3749C12.4844 14.2501 12.5743 14.215 12.6445 14.1447C12.7148 14.0742 12.7497 13.9846 12.7497 13.8751V7.12483C12.7497 7.01553 12.7147 6.92564 12.6445 6.85528C12.5743 6.78514 12.4844 6.75 12.3749 6.75H11.625C11.5154 6.75 11.4258 6.78509 11.3553 6.85528C11.2851 6.92564 11.25 7.01553 11.25 7.12483V13.8751C11.25 13.9846 11.2851 14.0743 11.3553 14.1447C11.4258 14.215 11.5154 14.2501 11.625 14.2501Z"
                      fill="white"/>
              </svg>
              Delete
            </div>
            <div class="dado__pick cursor-pointer block" @click="onMassChangeStatus(0)">
              <svg class='dado__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.0625 6.60938H12.7956V3.71848C12.7956 1.66809 11.0923 0 8.9987 0C6.90511 0 5.20182 1.66809 5.20182 3.71848V6.60938H3.9375C2.77439 6.60938 1.82812 7.55564 1.82812 8.71875V15.8906C1.82812 17.0537 2.77439 18 3.9375 18H14.0625C15.2256 18 16.1719 17.0537 16.1719 15.8906V8.71875C16.1719 7.55564 15.2256 6.60938 14.0625 6.60938ZM6.60807 3.71848C6.60807 2.4435 7.68052 1.40625 8.9987 1.40625C10.3169 1.40625 11.3893 2.4435 11.3893 3.71848V6.60938H6.60807V3.71848ZM14.7656 15.8906C14.7656 16.2783 14.4502 16.5938 14.0625 16.5938H3.9375C3.5498 16.5938 3.23438 16.2783 3.23438 15.8906V8.71875C3.23438 8.33105 3.5498 8.01562 3.9375 8.01562H14.0625C14.4502 8.01562 14.7656 8.33105 14.7656 8.71875V15.8906Z"
                      fill="white"/>
                <path d="M9 10.0547C8.28158 10.0547 7.69922 10.6371 7.69922 11.3555C7.69922 11.8142 7.93687 12.2171 8.29557 12.4488V13.9922C8.29557 14.3805 8.61036 14.6953 8.9987 14.6953C9.387 14.6953 9.70182 14.3805 9.70182 13.9922V12.4504C10.062 12.2191 10.3008 11.8153 10.3008 11.3555C10.3008 10.6371 9.71842 10.0547 9 10.0547Z"
                      fill="white"/>
              </svg>
              Block access
            </div>
            <div class="dado__pick cursor-pointer permit" @click="onMassChangeStatus(1)">
              <svg class='dado__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path d="M14.0625 6.60938H6.60807V3.71848C6.60807 2.4435 7.68052 1.40625 8.9987 1.40625C10.3169 1.40625 11.3893 2.4435 11.3893 3.71848V5.0625H12.7956V3.71848C12.7956 1.66809 11.0923 0 8.9987 0C6.90511 0 5.20182 1.66809 5.20182 3.71848V6.60938H3.9375C2.77439 6.60938 1.82812 7.55564 1.82812 8.71875V15.8906C1.82812 17.0537 2.77439 18 3.9375 18H14.0625C15.2256 18 16.1719 17.0537 16.1719 15.8906V8.71875C16.1719 7.55564 15.2256 6.60938 14.0625 6.60938ZM14.7656 15.8906C14.7656 16.2783 14.4502 16.5938 14.0625 16.5938H3.9375C3.5498 16.5938 3.23438 16.2783 3.23438 15.8906V8.71875C3.23438 8.33105 3.5498 8.01562 3.9375 8.01562H14.0625C14.4502 8.01562 14.7656 8.33105 14.7656 8.71875V15.8906Z"
                        fill="white"/>
                  <path d="M9 10.0547C8.28158 10.0547 7.69922 10.6371 7.69922 11.3555C7.69922 11.8142 7.93687 12.2171 8.29557 12.4488V13.9922C8.29557 14.3805 8.61036 14.6953 8.9987 14.6953C9.387 14.6953 9.70182 14.3805 9.70182 13.9922V12.4504C10.062 12.2191 10.3008 11.8153 10.3008 11.3555C10.3008 10.6371 9.71842 10.0547 9 10.0547Z"
                        fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="18" height="18" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              Permit access
            </div>
            <div class="dado__pick cursor-pointer xls" @click="onMassExport">
              <svg class='dado__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path d="M7.3126 10.3125H8.2501V12.75C8.2501 13.164 8.5861 13.5 9.0001 13.5C9.4141 13.5 9.7501 13.164 9.7501 12.75V10.3125H10.6876C11.1871 10.3125 11.4384 9.70575 11.0851 9.3525L9.3976 7.665C9.2881 7.55475 9.1441 7.5 9.0001 7.5C8.8561 7.5 8.7121 7.55475 8.6026 7.665L6.9151 9.3525C6.56185 9.70575 6.8131 10.3125 7.3126 10.3125Z"
                        fill="white"/>
                  <path d="M11.25 16.5H6.75C5.92275 16.5 5.25 15.8273 5.25 15V14.25C5.25 13.836 5.586 13.5 6 13.5C6.414 13.5 6.75 13.836 6.75 14.25V15H11.25V14.25C11.25 13.836 11.586 13.5 12 13.5C12.414 13.5 12.75 13.836 12.75 14.25V15C12.75 15.8273 12.0772 16.5 11.25 16.5Z"
                        fill="white"/>
                  <path d="M15.75 15.1875H14.625C14.2102 15.1875 13.875 14.8515 13.875 14.4375C13.875 14.0235 14.2102 13.6875 14.625 13.6875H15.75C16.164 13.6875 16.5 13.3507 16.5 12.9375V5.25C16.5 4.83675 16.164 4.5 15.75 4.5H7.6875C7.488 4.5 7.2975 4.42125 7.15725 4.28025L5.877 3H2.25C1.836 3 1.5 3.33675 1.5 3.75V12.9375C1.5 13.3507 1.836 13.6875 2.25 13.6875H3.375C3.78975 13.6875 4.125 14.0235 4.125 14.4375C4.125 14.8515 3.78975 15.1875 3.375 15.1875H2.25C1.0095 15.1875 0 14.178 0 12.9375V3.75C0 2.5095 1.0095 1.5 2.25 1.5H6.1875C6.387 1.5 6.5775 1.57875 6.71775 1.71975L7.998 3H15.75C16.9905 3 18 4.0095 18 5.25V12.9375C18 14.178 16.9905 15.1875 15.75 15.1875Z"
                        fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="18" height="18" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              XLS
            </div>
          </div>
          <div class="dado__array">
            <div class="dado__bred">
              <table class="table">
                <thead class="table__thead">
                <tr class="table__tr">
                  <th class="table__th"></th>
                  <th class="table__th">Status</th>
                  <th class="table__th">ID</th>
                  <th class="table__th">Name / Email</th>
                  <th class="table__th">Date Registered</th>
                  <th class="table__th">Phone Number</th>
                  <th class="table__th">Country</th>
                  <th class="table__th text-center">Test Done</th>
                  <th class="table__th"></th>
                </tr>
                </thead>
                <tbody class="table__tbody">
                <tr class="table__tr" v-for="user in getUsers">
                  <td class="table__td">
                    <div class="table__checkbox">
                      <label class="checkbox">
                        <input type="checkbox" @change="onSelectUser($event)" :checked="selectedUsers.indexOf(parseInt(user.id)) >= 0" :value="user.id"/>
                        <span class="checkbox__part"> </span>
                      </label>
                    </div>
                  </td>
                  <td class="table__td">
                    <div class="table__status" :class="{active: user.status, inactive: !user.status}"></div>
                  </td>
                  <td class="table__td">{{ user.mid }}</td>
                  <td class="table__td">{{ user.name }}<br>{{ user.email }}</td>
                  <td class="table__td">{{ user.created_at }}</td>
                  <td class="table__td">{{ user.phone }}</td>
                  <td class="table__td">{{ user.country ? user.country.name : '' }}</td>
                  <td class="table__td text-center">
                    <template v-if="user.test_data">
                      <span v-if="user.test_data.passed">{{ 'Yes (' + user.test_data.result + '%)' }}</span>
                      <span v-else>
                        <a :href="user.test_data.link_hash" target="_blank">No</a>
                        <br>
                        <span class="text-danger" v-if="user.test_data.failed_attempts">Failed: {{ user.test_data.failed_attempts }}</span>
                      </span>
                    </template>
                  </td>
                  <td class="table__td">
                    <div class="table__set">
                      <div class="table__pick cursor-pointer"
                           :class="user.status ? 'block' : 'permit'"
                           @click="onChangeStatus(user)"
                           v-tooltip="user.status ? 'Deactivate' : 'Activate'">
                        <svg class='table__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.0625 6.60938H12.7956V3.71848C12.7956 1.66809 11.0923 0 8.9987 0C6.90511 0 5.20182 1.66809 5.20182 3.71848V6.60938H3.9375C2.77439 6.60938 1.82812 7.55564 1.82812 8.71875V15.8906C1.82812 17.0537 2.77439 18 3.9375 18H14.0625C15.2256 18 16.1719 17.0537 16.1719 15.8906V8.71875C16.1719 7.55564 15.2256 6.60938 14.0625 6.60938ZM6.60807 3.71848C6.60807 2.4435 7.68052 1.40625 8.9987 1.40625C10.3169 1.40625 11.3893 2.4435 11.3893 3.71848V6.60938H6.60807V3.71848ZM14.7656 15.8906C14.7656 16.2783 14.4502 16.5938 14.0625 16.5938H3.9375C3.5498 16.5938 3.23438 16.2783 3.23438 15.8906V8.71875C3.23438 8.33105 3.5498 8.01562 3.9375 8.01562H14.0625C14.4502 8.01562 14.7656 8.33105 14.7656 8.71875V15.8906Z"
                                fill="white"/>
                          <path d="M9 10.0547C8.28158 10.0547 7.69922 10.6371 7.69922 11.3555C7.69922 11.8142 7.93687 12.2171 8.29557 12.4488V13.9922C8.29557 14.3805 8.61036 14.6953 8.9987 14.6953C9.387 14.6953 9.70182 14.3805 9.70182 13.9922V12.4504C10.062 12.2191 10.3008 11.8153 10.3008 11.3555C10.3008 10.6371 9.71842 10.0547 9 10.0547Z"
                                fill="white"/>
                        </svg>
                      </div>
                      <div @click="onShowEditModal(user)"
                           class="table__pick cursor-pointer edit"
                           v-tooltip="'Edit'">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.5548 7.38065C10.4067 7.38065 10.2866 7.50072 10.2866 7.64886V10.0303C10.2861 10.4745 9.92619 10.8345 9.48197 10.8349H1.95628C1.51206 10.8345 1.15218 10.4745 1.15165 10.0303V3.041C1.15218 2.59688 1.51206 2.23689 1.95628 2.23637H4.33769C4.48583 2.23637 4.6059 2.1163 4.6059 1.96816C4.6059 1.82012 4.48583 1.69995 4.33769 1.69995H1.95628C1.21598 1.70079 0.616073 2.3007 0.615234 3.041V10.0304C0.616073 10.7707 1.21598 11.3706 1.95628 11.3714H9.48197C10.2223 11.3706 10.8222 10.7707 10.823 10.0304V7.64886C10.823 7.50072 10.703 7.38065 10.5548 7.38065Z"
                                fill="white" stroke="white" stroke-width="0.4"/>
                          <path d="M10.7174 1.00977C10.246 0.538411 9.48183 0.538411 9.01047 1.00977L4.22544 5.7948C4.19265 5.82759 4.16897 5.86824 4.15661 5.91287L3.52737 8.18459C3.50149 8.27773 3.52778 8.37747 3.59609 8.44588C3.66451 8.51419 3.76425 8.54049 3.85739 8.51471L6.1291 7.88537C6.17374 7.873 6.21439 7.84932 6.24718 7.81653L11.0321 3.0314C11.5027 2.55973 11.5027 1.79617 11.0321 1.3245L10.7174 1.00977ZM4.80985 5.96913L8.72603 2.05285L9.98902 3.31585L6.07274 7.23213L4.80985 5.96913ZM4.55756 6.47538L5.5666 7.48452L4.17086 7.87122L4.55756 6.47538ZM10.6528 2.65213L10.3684 2.93658L9.10529 1.67348L9.38984 1.38903C9.65166 1.12721 10.0762 1.12721 10.338 1.38903L10.6528 1.70376C10.9142 1.96589 10.9142 2.39011 10.6528 2.65213Z"
                                fill="white" stroke="white" stroke-width="0.4"/>
                        </svg>
                      </div>
                      <div @click="onDelete(user)"
                           class="table__pick cursor-pointer delete"
                           v-tooltip="'Delete'">
                        <svg class='table__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17.1447 3.10532C17.0745 3.03517 16.9846 2.99991 16.8753 2.99991H13.2541L12.4338 1.04299C12.3166 0.753857 12.1056 0.507743 11.8011 0.304605C11.4963 0.101508 11.1875 0 10.8751 0H7.12503C6.81262 0 6.50395 0.101508 6.19927 0.304605C5.89454 0.507743 5.6836 0.753816 5.56637 1.04299L4.74606 2.99991H1.12496C1.01549 2.99991 0.92576 3.03517 0.855407 3.10532C0.785259 3.17563 0.75 3.26552 0.75 3.37487V4.12495C0.75 4.2343 0.785095 4.32419 0.855407 4.39438C0.92576 4.46465 1.01565 4.49978 1.12496 4.49978H2.24987V15.6562C2.24987 16.3048 2.43347 16.8574 2.80063 17.3144C3.16787 17.7716 3.60929 18 4.12495 18H13.8752C14.391 18 14.8323 17.7637 15.1995 17.2912C15.5667 16.8183 15.7502 16.2579 15.7502 15.6095V4.49978H16.8753C16.9846 4.49978 17.0745 4.46465 17.1447 4.39438C17.2148 4.32423 17.2502 4.2343 17.2502 4.12495V3.37487C17.2502 3.26552 17.2148 3.17563 17.1447 3.10532ZM6.94931 1.62864C7.00394 1.55836 7.07039 1.51527 7.14851 1.49975H10.8634C10.9415 1.51539 11.008 1.55845 11.0626 1.62864L11.6253 2.99975H6.37507L6.94931 1.62864ZM14.2503 15.6095C14.2503 15.7814 14.223 15.9396 14.1682 16.0841C14.1135 16.2285 14.0567 16.334 13.9983 16.4004C13.9395 16.467 13.8988 16.5 13.8752 16.5H4.12499C4.10155 16.5 4.06075 16.467 4.00202 16.4004C3.94336 16.334 3.88668 16.2285 3.83196 16.0841C3.77733 15.9396 3.74999 15.7812 3.74999 15.6095V4.49978H14.2503V15.6095H14.2503Z"
                                fill="white"/>
                          <path d="M5.62496 14.2501H6.37491C6.48438 14.2501 6.57432 14.215 6.64446 14.1447C6.71461 14.0742 6.74987 13.9846 6.74987 13.8751V7.12483C6.74987 7.01553 6.71461 6.92564 6.64446 6.85528C6.57411 6.78514 6.48443 6.75 6.37491 6.75H5.62496C5.51549 6.75 5.42572 6.78509 5.35541 6.85528C5.28518 6.92564 5.25 7.01553 5.25 7.12483V13.8751C5.25 13.9846 5.28505 14.0743 5.35541 14.1447C5.42572 14.215 5.51549 14.2501 5.62496 14.2501Z"
                                fill="white"/>
                          <path d="M8.62496 14.2501H9.37492C9.48435 14.2501 9.57424 14.215 9.64435 14.1447C9.71486 14.0742 9.74979 13.9846 9.74979 13.8751V7.12483C9.74979 7.01553 9.71482 6.92564 9.64435 6.85528C9.57424 6.78514 9.48435 6.75 9.37492 6.75H8.62496C8.51561 6.75 8.42572 6.78509 8.35541 6.85528C8.28505 6.92564 8.25 7.01553 8.25 7.12483V13.8751C8.25 13.9846 8.28505 14.0743 8.35541 14.1447C8.42568 14.215 8.51561 14.2501 8.62496 14.2501Z"
                                fill="white"/>
                          <path d="M11.625 14.2501H12.3749C12.4844 14.2501 12.5743 14.215 12.6445 14.1447C12.7148 14.0742 12.7497 13.9846 12.7497 13.8751V7.12483C12.7497 7.01553 12.7147 6.92564 12.6445 6.85528C12.5743 6.78514 12.4844 6.75 12.3749 6.75H11.625C11.5154 6.75 11.4258 6.78509 11.3553 6.85528C11.2851 6.92564 11.25 7.01553 11.25 7.12483V13.8751C11.25 13.9846 11.2851 14.0743 11.3553 14.1447C11.4258 14.215 11.5154 14.2501 11.625 14.2501Z"
                                fill="white"/>
                        </svg>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <v-pagination
                    v-if="pages > 1"
                    :page-count="pages"
                    :click-handler="onChangePage"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :prev-class="'pagination__prev'"
                    :next-class="'pagination__next'"
                    :page-class="'pagination__item'"
                    :active-class="'active'"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'

  export default {
    name: "Monitors",
    data() {
      return {
        filters: {
          country: 'All',
          status: 'All',
          role: 'Monitor',
          name: ''
        },
        statusesOptions: [
          {id: 'All', text: 'All'},
          {id: 1, text: 'Active'},
          {id: 0, text: 'Inactive'}
        ],
        selectedUsers: [],
      }
    },
    computed: {
      ...mapGetters([
        'getUsers',
        'getUsersPagination',
        'getCountriesNames',
      ]),
      pages() {
        if (this.getUsersPagination)
          return Math.ceil(this.getUsersPagination.count / this.getUsersPagination.per_page)
        return 0
      }
    },
    mounted() {
      this.setUsersFilters(this.filters)
      this.queryUsers()
      this.queryPartners()
    },
    methods: {
      ...mapActions([
        'showModal',
        'queryUsers',
        'queryPartners',
        'updateUser',
        'destroyUser',
        'massUpdateUsers',
        'massDestroyUsers',
        'exportUsers',
        'setPreloader',
        'setToast'
      ]),
      ...mapMutations([
        'setUsersFilters',
      ]),
      onClearName() {
        this.filters.name = ''
        this.onFilter()
      },
      onFilter() {
        this.setUsersFilters(this.filters)
        this.queryUsers()
      },
      onChangePage(page) {
        this.filters.page = page
        this.onFilter()
      },
      onShowCreateModal() {
        this.showModal({modal: 'ModalUser', data: {role: 'Monitor'}})
      },
      onShowEditModal(user) {
        this.showModal({modal: 'ModalUser', data: user})
      },
      onChangeStatus(user) {
        if (user.partner_id)
          this.updateUser([user.id, {status: user.status ? 0 : 1}])
        else
          this.setToast({message: 'Partner Organisation field is required', status: 'warning'})
      },
      onMassChangeStatus(status) {
        if (this.selectedUsers.length)
          this.massUpdateUsers({ids: this.selectedUsers, status: status})
      },
      onDelete(user) {
        let message = 'Delete user ' + user.name + '?';
        if (user.results_count)
          message = 'Delete user ' + user.name + ' and ' + user.results_count + ' of his reports?'

        this.$confirm({
          message: message,
          callback: confirm => {
            if (confirm)
              this.destroyUser(user.id)
          }
        })
      },
      onMassDelete() {
        this.$confirm({
          message: 'Delete users and their reports?',
          callback: confirm => {
            if (confirm) {
              this.massDestroyUsers(this.selectedUsers)
              this.selectedUsers = []
              this.onChangePage(1)
            }
          }
        })
      },
      onMassExport() {
        if (this.selectedUsers.length)
          this.exportUsers({ids: this.selectedUsers})
      },
      onSelectUser(event) {
        let val = parseInt(event.target.value)
        if (event.target.checked && this.selectedUsers.indexOf(val) == -1)
          this.selectedUsers.push(val)
        else
          this.selectedUsers.splice(this.selectedUsers.indexOf(val), 1)
      },
      onSelectAll(event) {
        this.selectedUsers = []
        if (event.target.checked)
          for (let id of this.getUsersPagination.ids)
            this.selectedUsers.push(id)
      }
    }
  }
</script>

<style lang="scss">
  .monitors {
    .table__td,
    .table__th {
      padding: 24px 10px !important
    }
  }
</style>